/**
 * @generated SignedSource<<97b7216bb78b06706ceb8eca5c62ea3d>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type NaturalLanguageToJQLWrapper_withAIFilters$data = {
  readonly " $fragmentSpreads": FragmentRefs<"JQLBuilderEmbedded_withAIFilters">;
  readonly " $fragmentType": "NaturalLanguageToJQLWrapper_withAIFilters";
};
export type NaturalLanguageToJQLWrapper_withAIFilters$key = {
  readonly " $data"?: NaturalLanguageToJQLWrapper_withAIFilters$data;
  readonly " $fragmentSpreads": FragmentRefs<"NaturalLanguageToJQLWrapper_withAIFilters">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "NaturalLanguageToJQLWrapper_withAIFilters",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "JQLBuilderEmbedded_withAIFilters"
    }
  ],
  "type": "JiraQuery"
};

(node as any).hash = "361965b4f7eb260781dfaa76c846fb3d";

export default node;
